const userRoutes = [
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/User/User.vue')
  }
]

export default userRoutes
